export type THttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';

export enum ProductTier {
  STARTER = 'starter',
  CORE = 'core',
  PREMIUM = 'premium',
}

export enum AddonModule {
  CENTRAL_KITCHEN = 1,
}

export enum Action {
  CREATE = 'create',
  READ = 'read',
  UPDATE = 'update',
  DELETE = 'delete',
}

/**
 * Languages & Regions supported by CBO
 */
export const languages = ['en-US', 'es-MX', 'fr-CA']; // Needed for data validation
export type TLanguage = 'en-US' | 'es-MX' | 'fr-CA';
export const filterType = ['dateRange', 'enterpriseUnitIds'];
export type TFilterType = 'dateRange' | 'enterpriseUnitIds';

export const regions = ['en-US', 'es-MX', 'fr-CA']; // Needed for data validation
export type TRegion = 'en-US' | 'es-MX' | 'fr-CA';
